import React, { useContext, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const PayResult = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const clearCartRef = useRef(clearCart);
  const isSuccess = searchParams.get("state") === "success";

  useEffect(() => {
    if (isSuccess) clearCartRef.current();
  }, [isSuccess]);

  return (
    <div className="successDiv">
      <div className="success-container">
        <div className={`modal-content payment-result payment-result--${isSuccess ? "success" : "cancel"}`}>
          <div className="checkmark-circle">
            <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
          </div>
          <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
          <p>
            {isSuccess
              ? "Thank you. Your payment has been received."
              : "Your payment was not completed. Your cart has been kept so you can try again."}
          </p>
          <Link className="payment-result__link" to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PayResult;
